import createSelector from "../../utils/reselect";

const userStateData = (state) => {
  const { users } = state;
  return users || {};
};

export const getUser = createSelector(userStateData, (users) => {
  const u = users.get("user") || null;
  if (u) {
    return JSON.parse(JSON.stringify(u));
  }
  return u;
});

export const usersLoading = createSelector(userStateData, (users) =>
  users.get("usersLoading")
);

export const rolesLoading = createSelector(userStateData, (users) =>
  users.get("rolesLoading")
);

export const userLoading = createSelector(userStateData, (users) =>
  users.get("loading")
);

export const shouldPermissionModalOpen = createSelector(
  userStateData,
  (users) => users.get("shouldPermissionModalOpen")
);

export const getError = createSelector(userStateData, (users) =>
  users.get("error")
);

export const updateInfoLoading = createSelector(userStateData, (users) =>
  users.get("updateInfoLoading")
);

export const workingHoursLoading = createSelector(userStateData, (users) =>
  users.get("workingHoursLoading")
);

export const updatePicLoading = createSelector(userStateData, (users) =>
  users.get("updatePicLoading")
);

export const saveRoleLoading = createSelector(userStateData, (users) =>
  users.get("saveRoleLoading")
);

export const permissionLoader = createSelector(userStateData, (users) =>
  users.get("permissionLoading")
);

export const updatePermissionLoading = createSelector(userStateData, (users) =>
  users.get("updatePermissionLoading")
);

export const userStatusLoading = createSelector(userStateData, (users) =>
  users.get("userStatusLoading")
);

export const passwordLoading = createSelector(userStateData, (users) =>
  users.get("passwordLoading")
);

export const roles = createSelector(userStateData, (users) =>
  users.get("roles")
);

export const rolesPagination = createSelector(userStateData, (users) =>
  users.get("rolesPagination")
);

export const usersPagination = createSelector(userStateData, (users) =>
  users.get("usersPagination")
);

export const permissions = createSelector(userStateData, (users) =>
  users.get("permissions")
);

export const users = createSelector(userStateData, (users) =>
  users.get("users")
);

export const groups = createSelector(userStateData, (users) =>
  users.get("groups")
);
